
import axios from "../api/axiosInstance";

export const getComplaintGroup = () => {
  return axios.get("/Complaint/GetAllCompaintGroup");
};

export const getComplaints = () => {
    return axios.get("/Complaint/GetAllComplaint");
  };

  export const getComplaintDetails= (requestNo) => {
    return axios.get("/Complaint/GetComplaintByRequestNo", {
      params: { requestNo },
    });
  };

  export const addComplaint = (complaintData) => {
    return axios.post("/Complaint/AddComplaint", complaintData);
  };
  
